import type { PatientMedicalAidMembership } from '@quromedical/models';
import { DisplayView } from 'components/fhir';
import { FormCard, type RowConfig } from 'design-system';
import type React from 'react';
import { strings } from 'strings';

interface Props {
  coverage?: Partial<PatientMedicalAidMembership>;
}

const createMedicalAidRowConfigs = (
  coverage?: Partial<PatientMedicalAidMembership>,
): RowConfig[] => [
  {
    fields: [
      {
        type: 'custom',
        label: strings.CardLabelScheme,
        Display: () => <DisplayView reference={coverage?.scheme} />,
      },
      {
        type: 'text',
        label: strings.CardLabelPlanAndOption,
        display: coverage?.plan,
      },
    ],
  },
  {
    fields: [
      {
        type: 'text',
        label: strings.FormLabelMedicalAidNumber,
        display: coverage?.memberNumber,
      },
      {
        type: 'text',
        label: strings.CardLabelDependantCode,
        display: coverage?.dependantCode,
      },
    ],
  },
];

export const PatientMedicalAidMembershipCard: React.FC<Props> = ({
  coverage,
}) => {
  const medicalAidRowConfigs = createMedicalAidRowConfigs(coverage);

  return (
    <FormCard
      title={strings.CardLabelMedicalAidDetails}
      rows={medicalAidRowConfigs}
      showIcons={false}
    />
  );
};
